const SETUP_STEPS = [
  {
    n: '01',
    title: 'Connect your broker',
    desc: 'Guided connection for FYERS, Zerodha, and MasterTrust. Nuvama integration is currently in testing.',
  },
  {
    n: '02',
    title: 'Create your TradingView alert',
    desc: 'Your existing Pine Script strategy or indicator condition — nothing in your script changes.',
  },
  {
    n: '03',
    title: 'Add the AlgoSys webhook',
    desc: "Paste your webhook URL and message format into the alert's notification settings.",
  },
  {
    n: '04',
    title: 'Define your risk rules',
    desc: 'Target, Stop Loss, and Trailing Stop Loss — decided before the trade, not during it.',
  },
];

const RUNTIME_STEPS = [
  {
    n: '05',
    title: 'The alert fires',
    desc: 'TradingView sends the signal to your webhook the moment your condition triggers.',
  },
  {
    n: '06',
    title: 'AlgoSys places the order',
    desc: 'The signal becomes a live order at your broker — no typing, no missed notification.',
  },
  {
    n: '07',
    title: 'AlgoSys manages the trade',
    desc: 'Target, SL, and TSL tracked and acted on automatically until the position closes.',
  },
  {
    n: '08',
    title: 'You watch — or step in',
    desc: 'Live P/L on the dashboard. Pause, exit, or kill whenever you choose.',
  },
];

function StepGroup({ label, steps }) {
  return (
    <div>
      <div className="section-title text-amber">{label}</div>
      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-5">
        {steps.map((step, i) => (
          <div key={step.n} className="relative flex gap-4 md:block md:gap-0">
            {/* Mobile vertical timeline connector */}
            <div className="flex flex-col items-center md:hidden">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full border border-amber/40 bg-bg-panel font-display text-xs font-bold text-amber">
                {step.n}
              </span>
              {i < steps.length - 1 && <span className="mt-1 w-px flex-1 bg-bg-border" />}
            </div>
            <div className="card p-5 md:p-6 pb-8 md:pb-6">
              <div className="hidden font-display text-xs font-bold text-amber md:block">{step.n}</div>
              <h3 className="mt-0 font-display text-base font-bold text-txt-primary md:mt-3">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-txt-secondary">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function HowItWorksStepper() {
  return (
    <div className="space-y-10">
      <StepGroup label="Set up once" steps={SETUP_STEPS} />
      <StepGroup label="Runs on every alert" steps={RUNTIME_STEPS} />
    </div>
  );
}
